import { render, staticRenderFns } from "./DeliveryWaybillDetails.vue?vue&type=template&id=5645b434&scoped=true&"
import script from "./DeliveryWaybillDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryWaybillDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryWaybillDetails.vue?vue&type=style&index=0&id=5645b434&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645b434",
  null
  
)

export default component.exports